import { UNIVERSAL_SEARCH_SCOPES } from '@terros/common'
import { z } from 'zod'

export const UNIVERSAL_SEARCH_GROUPS = [...UNIVERSAL_SEARCH_SCOPES, 'all'] as const
export const UniversalSearchGroupSchema = z.enum(UNIVERSAL_SEARCH_GROUPS)
export type UniversalSearchGroup = z.infer<typeof UniversalSearchGroupSchema>
